import { render, staticRenderFns } from "./PropertySetting.vue?vue&type=template&id=c12ec1da&scoped=true"
import script from "./PropertySetting.vue?vue&type=script&lang=js"
export * from "./PropertySetting.vue?vue&type=script&lang=js"
import style0 from "./PropertySetting.vue?vue&type=style&index=0&id=c12ec1da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c12ec1da",
  null
  
)

export default component.exports